// ADR-0129 §7 — dos constantes deliberadamente separadas.
/** El string que el servidor estampa en `findings.taxonomy_version` en
 *  cada inserción de clasificación. NUNCA viene del cliente (versión
 *  suministrada por cliente = procedencia forjable). Única sede del
 *  literal — fitness: taxonomy-version-single-constant. */
export const TAXONOMY_VERSION_CURRENT = "2.1-mvp";
/** Procedencia del contenido: el xlsx fuente de las filas se
 *  autodeclara 2.0-mvp en su hoja Léeme. El documento de arquitectura
 *  (docs/postventa-taxonomy.md, v2.1-mvp) gana en conflicto y es el
 *  que fija el string estampado. Si en el futuro cambia el catálogo
 *  sin cambiar la arquitectura — o viceversa — solo una de las dos
 *  constantes sube. */
export const SOURCE_XLSX_VERSION = "2.0-mvp";
//# sourceMappingURL=version.js.map